import {
  ISocketDetailsCounter,
  ISocketDetailsNewMessage,
  ISocketMessage,
  ISocketNotificationCounter,
  ISocketNotificationEvent,
  SocketNotificationCounterType,
  SocketNotificationEventType,
  SocketNotificationMessageType,
  SocketNotificationType,
} from './types';

const mapNewMessage = (data: ISocketMessage) => {
  const details = data.details as ISocketDetailsNewMessage;

  return {
    [SocketNotificationType.EVENT]: {
      message: details.message,
      sender_id: String(details.sender.id),
      date: data.submissionDate,
      source: data.source,
      type: SocketNotificationEventType.NEW_MESSAGE_RECEIVED,
    } as ISocketNotificationEvent,
  };
};

const mapCounter = (data: ISocketMessage) => {
  const details = data.details as ISocketDetailsCounter;
  let type;

  switch (data.notificationType) {
    case SocketNotificationMessageType.COUNTER_LIKE:
      type = SocketNotificationCounterType.FAVORITE;
      break;

    case SocketNotificationMessageType.COUNTER_MESSAGE:
      type = SocketNotificationCounterType.MESSAGE;
      break;

    case SocketNotificationMessageType.COUNTER_VISIT:
      type = SocketNotificationCounterType.VISIT;
      break;
  }

  return {
    [SocketNotificationType.COUNTER]: {
      type,
      value: details.counterValue,
    } as ISocketNotificationCounter,
  };
};

export const mapSocketMessage = (data: ISocketMessage) => {
  switch (data.notificationType) {
    case SocketNotificationMessageType.EVENT_NEW_MESSAGE:
      return mapNewMessage(data);

    case SocketNotificationMessageType.COUNTER_LIKE:
    case SocketNotificationMessageType.COUNTER_MESSAGE:
    case SocketNotificationMessageType.COUNTER_VISIT:
      return mapCounter(data);
  }
};
